/**
 * Účty napříč adresáři. Core widget: dá se položit na libovolný panel,
 * nepatří jednomu modulu. SSO, Identity i dashboard ho berou stejně.
 */
import { Users } from 'lucide-react';
import type { WidgetSpec } from './types';
import DirectoryAccounts from '../pages/DirectoryAccounts';

export const PEOPLE_WIDGETS: WidgetSpec[] = [
  {
    id: 'people.accounts',
    title: 'People',
    kind: 'custom',
    format: 'lg',
    formats: ['lg'],
    icon: Users,
    component: DirectoryAccounts,
    phone: DirectoryAccounts,
  },
];
